import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
  entity: {
      id: 0,
      idAreaObjetivo: 0,
      idModelo: 0,
      codigoModelo: "",
      modelo: "",
      idArea: 0,
      codigoArea: "",
      area: "",
      idDestreza: 0,
      codigoDestreza: "",
      destreza: "",
      codigoObjetivo: "",
      objetivo: "",
      valor: 0,
      descripcion: "",
      orden: 0,
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  },
  listAreaObjetivo: [{id: 0, codigo: "", nombre: "", descripcion: "", pregunta: "", ejemplo: ""}],
  validationActive: {
      idAreaObjetivo: false,
      descripcion: false,
      orden: false,
  },
  validationMessage: [],
}
  
export const areaObjectiveCriterionSlice = createSlice({
  name: "areaObjectiveCriterion",
  initialState: {},
  reducers: {
    init: (state, action) => {
      const { sliceKey } = action.payload;
      if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
    },
    setEntity: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].entity = data;
    },
    setData: (state, action) => {
      var { sliceKey, name, value } = action.payload;

      if (name.startsWith("id")) value = parseInt(value)
      if (name.startsWith("orden")) value = parseInt(value)
      if (name.startsWith("valor")) value = parseInt(value)
      
      state[sliceKey].entity[name] = value
      state[sliceKey].validationActive[name] = true
    },
    setListAreaObjetivo: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].listAreaObjetivo = data;
    },
    setValidationMessage: (state, action) => {
      const {sliceKey, message} = action.payload;
      state[sliceKey].validationMessage = message;
    },
    activeValidations: (state, action) => {
      const {sliceKey} = action.payload;
      Object.keys(state[sliceKey].validationActive).forEach(function (key) {
        state[sliceKey].validationActive[key] = true;
      })
    },
  },
});
  
export const { init, setEntity, setData, setValidationMessage, activeValidations
  , setListAreaObjetivo
} = areaObjectiveCriterionSlice.actions;
export const defaultEntity = {
    id: 0,
    idAreaObjetivo: 0,
    idModelo: 0,
    codigoModelo: "",
    modelo: "",
    idArea: 0,
    codigoArea: "",
    area: "",
    idDestreza: 0,
    codigoDestreza: "",
    destreza: "",
    codigoObjetivo: "",
    objetivo: "",
    valor: 0,
    descripcion: "",
    orden: 0,
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}
export default areaObjectiveCriterionSlice.reducer;
